import axios from "axios";

export const fetchBackups = async () => {
  const { data } = await axios.get("/api/admin/backups");
  return data;
};

export const downloadBackup = async (filename) => {
  const res = await axios.get(`/api/admin/backups/${encodeURIComponent(filename)}/download`, {
    responseType: "blob",
  });

  const blob = new Blob([res.data], { type: "application/octet-stream" });
  const url = window.URL.createObjectURL(blob);

  const a = document.createElement("a");
  a.href = url;
  a.download = filename;
  document.body.appendChild(a);
  a.click();
  a.remove();

  window.URL.revokeObjectURL(url);
};
